export const ActionTypes = {
    SET_USER: "SET_USER",
    SET_ACTIVEUSER: "SET_ACTIVEUSER",
    SET_CONNECTEDACCOUNTS:"SET_CONNECTEDACCOUNTS",
    SET_MODALACCOUNTS:"SET_MODALACCOUNTS",
};